/**
 * El desglose de un tramo de la portada: quién pone qué (spec 034).
 */
import type { ContadoresVista } from '../components/Contadores'

export type ClaveContador = keyof ContadoresVista

export function rutaContador(
    clave: ClaveContador,
    accountId: number,
    periodo: string,
    incluirTests = false,
): string {
    if (clave === 'enEspera') return `/business/${accountId}/espera`
    return `/business/${accountId}/counter/${clave}?periodo=${periodo}${incluirTests ? '&incluirTests=1' : ''}`
}

export interface NegocioEnPortada {
    accountId: number
    name: string
    contadores: ContadoresVista
}

export interface FilaTramo {
    accountId: number
    name: string
    valor: number
    destino: string
}

export function filasDeTramo(
    negocios: readonly NegocioEnPortada[],
    clave: ClaveContador,
    periodo: string,
    incluirTests = false,
): FilaTramo[] {
    return [...negocios]
        .map((n) => ({
            accountId: n.accountId,
            name: n.name,
            valor: n.contadores[clave],
            destino: rutaContador(clave, n.accountId, periodo, incluirTests),
        }))
        .sort((a, b) => b.valor - a.valor || a.name.localeCompare(b.name, 'es'))
}
